import { ConfigService } from '../../';

export class MenuLink {
	public image	= ''
	public text		= ''
	public url		= ''

	constructor(data: any, text?: string, url?: string, private configService?: ConfigService) {
		if (typeof data === 'object') {
			if (typeof data.image	=== 'string') {
				this.image = configService.getImage(data.image);
			} else {
				this.image
			}
			this.text		= typeof data.text	=== 'string'	? data.text		: this.text
			this.url		= typeof data.url		=== 'string'	? data.url		: this.url
		} else if (typeof data === 'string') {
			this.image	= typeof data	=== 'string'	? configService.getImage(data)	: this.image
			this.text		= typeof text	=== 'string'	? text	: this.text
			this.url		= typeof url	=== 'string'	? url		: this.url
		}
	}
}


// WEBPACK FOOTER //
// ./src/app/electraLib/model/ui/menuLink.ts